import { FormState } from "../components/CheckoutForm";
import { IState } from "country-state-city";

interface ValidateBillingFormParams {
  formData: FormState;
  states: IState[];
}

interface ValidationResult {
  isValid: boolean;
  errors: string[];
}

export type FieldErrors = Partial<Record<keyof FormState, string>>;

interface ValidateFieldParams {
  field: keyof FormState;
  value: string;
  states: IState[];
}

export function validateField({ field, value, states }: ValidateFieldParams): string | undefined {
  const trimmedValue = value.trim();

  switch (field) {
    case "firstName":
      return !trimmedValue ? "First name is required" : undefined;
    case "lastName":
      return !trimmedValue ? "Last name is required" : undefined;
    case "address1":
      return !trimmedValue ? "Address is required" : undefined;
    case "city":
      return !trimmedValue ? "City is required" : undefined;
    case "state":
      return states.length > 0 && !trimmedValue ? "State/Province is required" : undefined;
    case "postalCode":
      return !trimmedValue ? "Zip/Postal code is required" : undefined;
    case "country":
      return !trimmedValue ? "Country is required" : undefined;
    default:
      return undefined;
  }
}

export function validateBillingForm({ formData, states }: ValidateBillingFormParams): ValidationResult {
  const errors: string[] = [];

  if (!formData.firstName.trim()) errors.push("First name is required");
  if (!formData.lastName.trim()) errors.push("Last name is required");
  if (!formData.address1.trim()) errors.push("Address is required");
  if (!formData.city.trim()) errors.push("City is required");
  if (states.length > 0 && !formData.state.trim()) {
    errors.push("State/Province is required");
  }
  if (!formData.postalCode.trim()) errors.push("Zip/Postal code is required");
  if (!formData.country.trim()) errors.push("Country is required");

  return {
    isValid: errors.length === 0,
    errors,
  };
}

export function validateAllFields({ formData, states }: ValidateBillingFormParams): FieldErrors {
  const fieldErrors: FieldErrors = {};
  const fields: (keyof FormState)[] = ["firstName", "lastName", "address1", "city", "state", "postalCode", "country"];

  for (const field of fields) {
    const error = validateField({ field, value: formData[field], states });
    if (error) {
      fieldErrors[field] = error;
    }
  }

  return fieldErrors;
}
